module.exports = __webpack_public_path__ + "img/mintz22.4e623de4.png";